import { render } from "./ProjectDetails.vue?vue&type=template&id=422143e5&scoped=true&ts=true"
import script from "./ProjectDetails.vue?vue&type=script&lang=ts"
export * from "./ProjectDetails.vue?vue&type=script&lang=ts"

import "./ProjectDetails.vue?vue&type=style&index=0&id=422143e5&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-422143e5"]])

export default __exports__